import Modal from 'LuxKit/Modal/Modal'
import Table from 'LuxKit/Tables/Table'
import TableBody from 'LuxKit/Tables/TableBody'
import TableBodyCell from 'LuxKit/Tables/TableBodyCell'
import TableBodyRow from 'LuxKit/Tables/TableBodyRow'
import TableHeader from 'LuxKit/Tables/TableHeader'
import TableHeaderCell from 'LuxKit/Tables/TableHeaderCell'
import TableHeaderRow from 'LuxKit/Tables/TableHeaderRow'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import React from 'react'
import { useIntl } from 'react-intl'

function LoyaltyLandingPageMovingTiersModal() {
  const intl = useIntl()

  const modalTitle = intl.formatMessage({
    id: 'pLXy6ymRfhDW2pO72ZhO',
    defaultMessage: 'Moving through the tiers',
    description: 'Title for the tier progression details modal in the loyalty section',
  })
  const modalBody = intl.formatMessage({
    id: 'mhudR5ZkC7qedN04wGdA',
    defaultMessage: 'The below is what you’ll need to achieve within your calendar year to progress to the next tier or retain your current tier.',
    description: 'Explanation of tier progression requirements in the modal',
  })
  const tierHeader = intl.formatMessage({
    id: 'Vze_BWOaUCTN-uuzhZjl',
    defaultMessage: 'Tier',
    description: 'Table column header for loyalty tier name in the loyalty section',
  })
  const statusCreditsHeader = intl.formatMessage({
    id: '5f3glCTwRtuQn_pBrVDp',
    defaultMessage: 'Status Credits',
    description: 'Table column header for required Status Credits count',
  })
  const nightsHeader = intl.formatMessage({
    id: 'q7CPUyAJ4GEnHji-v6E5',
    defaultMessage: 'Number of nights',
    description: 'Table column header for required number of nights stayed',
  })
  const silverLabel = intl.formatMessage({
    id: 'pXD_8aEdkk-iq06yzX3k',
    defaultMessage: 'Silver',
    description: 'Silver tier name in tier progression table in the loyalty section',
  })
  const goldLabel = intl.formatMessage({
    id: 'bwyH9mz2wbdqVsqdSfT8',
    defaultMessage: 'Gold',
    description: 'Gold tier name in tier progression table in the loyalty section',
  })
  const platinumLabel = intl.formatMessage({
    id: '_bp2EvL3wWf3psZCtFMV',
    defaultMessage: 'Platinum',
    description: 'Platinum tier name in tier progression table in the loyalty section',
  })

  return <Modal size="S" title={modalTitle}>
    <Group direction="vertical" gap={16}>
      <BodyText variant="medium">
        {modalBody}
      </BodyText>
      <Table>
        <TableHeader>
          <TableHeaderRow>
            <TableHeaderCell>
              <BodyText variant="small" weight="bold">
                {tierHeader}
              </BodyText>
            </TableHeaderCell>
            <TableHeaderCell>
              <BodyText variant="small" weight="bold">
                {statusCreditsHeader}
              </BodyText>
            </TableHeaderCell>
            <TableHeaderCell>
              <BodyText variant="small" weight="bold">
                {nightsHeader}
              </BodyText>
            </TableHeaderCell>
          </TableHeaderRow>
        </TableHeader>
        <TableBody>
          <TableBodyRow>
            <TableBodyCell>
              <BodyText variant="small" weight="bold">
                {silverLabel}
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                {intl.formatNumber(200)}
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                {intl.formatNumber(10)}
              </BodyText>
            </TableBodyCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableBodyCell>
              <BodyText variant="small" weight="bold">
                {goldLabel}
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                {intl.formatNumber(600)}
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                {intl.formatNumber(20)}
              </BodyText>
            </TableBodyCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableBodyCell>
              <BodyText variant="small" weight="bold">
                {platinumLabel}
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                {intl.formatNumber(1000)}
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                {intl.formatNumber(30)}
              </BodyText>
            </TableBodyCell>
          </TableBodyRow>
        </TableBody>
      </Table>
    </Group>
  </Modal>
}

export default LoyaltyLandingPageMovingTiersModal
